import React from "react";
import Icon from "components/Icon";
//import PropTypes from 'prop-types';

const statusIcons = {
    success: "mui-mark_email_read",
    failed: "mui-unsubscribe",
    failed_challenge: "mui-warning",
    pending: "mui-mail_outline",
};
export function StatusIcon({ status, ...rest }) {
    return <Icon {...rest}>{statusIcons[status]}</Icon>;
}

StatusIcon.propTypes = {};

StatusIcon.defaultProps = {};

export default StatusIcon;
